var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"loadingdiv"}},[_c('p',[_vm._v("User Data Invalid")]),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-primary",attrs:{"type":"submit"},on:{"click":_vm.hispec}},[_vm._v("Go Back")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ccb8d808","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ErrorPage.vue
// module id = null
// module chunks = 